export const ADD_COMMENT = 'add comment';
export const LIKE_COMMENT = 'like comment';
export const REMOVE_COMMENT_LIKE = 'remove comment like';
export const EDIT_COMMENT = 'edit comment';
export const DELETE_COMMENT = 'delete comment';
export const REPLY__COMMENT = 'reply comment';